import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=54c85623&scoped=true&"
import script from "./LoadingPage.vue?vue&type=script&lang=js&"
export * from "./LoadingPage.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=54c85623&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c85623",
  null
  
)

export default component.exports